import React from "react";
import Button from "@mui/material/Button";
import MenuItems from "./MenuItems";

const MenuItem = ({ menuId, anchorEl, menuItems, openAnchor, handleClick, handleClose }: any) => {
  return menuItems?.map(({ id, title, options }: any) => (
    <React.Fragment key={id}>
      <Button
        id={id}
        aria-haspopup='true'
        onClick={handleClick}
        sx={{ color: "#fff" }}
        aria-controls={openAnchor ? title : undefined}
        aria-expanded={openAnchor ? "true" : undefined}
      >
        {title}
      </Button>
      <MenuItems
        itemId={title}
        menuId={menuId}
        ariaControl={id}
        options={options}
        anchorEl={anchorEl}
        handleClose={handleClose}
      />
    </React.Fragment>
  ));
};

export default MenuItem;
